// Одно и то же число доезжает до расчёта в разных записях: из справочника
// номенклатуры нормы приходят строкой («1.44», иногда с запятой), из расчёта
// сравнения производств — числом, а formatCalculatedValue возвращает строку.
// Строгое сравнение считало такие значения разными, и код «поменялось ли?»
// отвечал «да» на каждый пересчёт: пересоздавались строки товаров и наборы
// номенклатуры, а за сменой ссылок вхолостую уходил полный круг запросов —
// сравнение производств, способы доставки, пересборка расчёта заказа.
//
// Здесь сравнивается именно значение. Записи (число/строка) считаются равными,
// если обе разбираются в одно и то же конечное число.
const toComparableNumber = (value) => {
  if (value === null || value === undefined || value === "") {
    return NaN;
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : NaN;
  }

  const parsed = parseFloat(String(value).replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(parsed) ? parsed : NaN;
};

export const isSameNumericValue = (a, b) => {
  if (a === b) {
    return true;
  }

  const numA = toComparableNumber(a);
  const numB = toComparableNumber(b);
  return Number.isFinite(numA) && Number.isFinite(numB) && numA === numB;
};

export default isSameNumericValue;
